import { useState, useRef, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Modal, Row, Drawer, Button, Spin, Form } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "react-aspect-ratio/aspect-ratio.css";
import "../../../style.css";
import "../styles.css";
import "../../../globalStyles.css";
import "react-simple-keyboard/build/css/index.css";
import { useWindowDimensions } from "../../../../lib/useViewport";
import BarCodeComponentForRetail from "../../../../lib/BarCodeComponentForRetail";
import BarCodeComponentForNoFocus from "../../../../lib/BarCodeComponentForNoFocus";
import { clock } from "../../../../utils/clock";
import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import { useEventBus } from "../../../../lib/components/EventBusProvider";
import POSLogo from "../../../../assets/images/NewLogoCW.svg";
import leftLoading from "../../../../assets/images/opo.gif";
import FilterIcon from "../../../../assets/images/filterNewICon.svg";
import ScanIcon from "../../../../assets/images/scanIcon.svg";
import Discard from "../../../../assets/images/return.png";
import RetailModals from "../RetailModals";
import QuantityUpdate from "../QuantityUpdate";
import useSyncProgressStore from "../../../../stores/useSyncProgressStore";
import useSessionStore from "../../../../stores/useSessionStore";
import { useTranslation } from "react-i18next";
import ProductPanelSM from "../productPanelSM";
import LoadingScreen from "./LoadingScreen";
import CustomMixModal from "../../CustomMix/CustomMixModal";
import QuotationComponent from "../Quotation";
import RenderInput from "../../../../lib/components/RenderInput";
import useAdditionalCharges from "./hooks/useAdditionalCharges";
import useCartHistory from "./hooks/useCartHistory";
import useSuperMarketReturn from "./hooks/useSuperMarketReturn";
import CartHistoryView from "./CartHistoryView";
import SideMenuDrawer from "./SideMenuDrawer";
import AdditionalChargesDrawer from "./AdditionalChargesDrawer";
import useSuperMarketHandlers from "./useSuperMarketHandlers";
import SMHeader from "./SMHeader";
import SMParkedBillsView from "./SMParkedBillsView";
import SMEstimatesView from "./SMEstimatesView";
import SMPurchaseReturnView from "./SMPurchaseReturnView";
import SMPrintTemplateModal from "./SMPrintTemplateModal";
import SMReturnReasonDrawer from "./SMReturnReasonDrawer";
import SMCartTable from "./SMCartTable";
import SMCartSummary from "./SMCartSummary";
import SMProductDetailsPanel from "./SMProductDetailsPanel";
import SMPaymentBar from "./SMPaymentBar";
import SMCashManagementView from "./SMCashManagementView";
import SMLockScreen from "./SMLockScreen";
import SMOrderSelectionView from "./SMOrderSelectionView";
import SMVirtualKeyboardDrawer from "./SMVirtualKeyboardDrawer";
import SMCustomerBar from "./SMCustomerBar";
import SMCartMenuButtons from "./SMCartMenuButtons";
import { orderHistoryColumns, parkedBillColumns } from "./SMTableColumns";
import useProductSearch from "./hooks/useProductSearch";
import useSuperMarketActions from "./hooks/useSuperMarketActions";
import useSuperMarketEffects from "./hooks/useSuperMarketEffects";
import useCartStore from "../../../../stores/useCartStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useAuthStore from "../../../../stores/useAuthStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import {
  renderCustomerWallet as renderCustomerWalletHelper,
  renderPaymentsData as renderPaymentsDataHelper,
  watermark as watermarkHelper,
  showConfirm as showConfirmHelper,
  parseTillAccessMeta,
} from "./SMRenderHelpers";

const posConfigInit = usePOSConfigStore.getState().posConfig;
const themeJSON =
  posConfigInit?.themeJSON && posConfigInit?.themeJSON !== "N" && Object.keys(posConfigInit?.themeJSON).length > 0 ? JSON.parse(posConfigInit?.themeJSON)?.layout4 : {};

const PointOfSaleMarket = (props) => {
  const { t } = useTranslation();
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  let parkedBillRef = useRef();
  let searchCustomersRef = useRef();

  const redirectUrl = process.env.REACT_APP_redirectURL;
  const domainURL = process.env.REACT_APP_domain;
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const authHeaders = getOAuthHeaders();
  const userData = useAuthStore.getState().userData;
  const { dispatchEvent, dispatchItemSelection } = useEventBus();
  const {
    record,
    form,
    addProduct,
    cart,
    setCart,
    checkIsManualWeight,
    clearProductSearchResults,
    closeProductPanel,
    showAddNewCustomerFields,
    decreaseProductQty,
    deleteCart,
    giftCardData,
    setGiftCardData,
    deleteProduct,
    getMoreProducts,
    getSearchedProducts,
    increaseProductQty,
    isProductsFilter,
    isQtyUpdate,
    loader,
    loading,
    setLoading,
    // detailsLoading,
    onBarcodeInput,
    openDisplayParkedBillModal,
    setFilterdDate,
    orderType,
    parkBill,
    parkedList,
    setShowProductionOrder,
    productSearchInput,
    selectProductInCart,
    selectedProductInCart,
    selectedRowKeys,
    selectedKeys,
    setDisplayCustomerSearch,
    setDisplayUAECustomerSearch,
    setCloseCustomerFlag,
    setIsProductsFilter,
    setQtyNumberFlag,
    filtersFlag,
    setFiltersFlag,
    setIsQtyUpdate,
    setIsSearchProducts,
    setProductSearchInput,
    showOrderHistory,
    tillData,
    setManualDiscountInput,
    setSelectedManualDiscountTypeValue,
    prevHistoryRef,
    setManualDiscountModalVisible,
    setDisplayOfferProductSelection,
    offerProductsList,
    clearSelectedProductInCart,
    productListCardRef,
    posLogActivity,
    upsertPOSLog,
    removeCutomer,
    handleLoyaltyPayment,
    onChangeTotalQuantity,
    filterDrawer,
    setFilterDrawer,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    searchParkedBill,
    parkedBillSearchInput,
    filterdParkedList,
    discardParkedBill,
    setFilterdParkedList,
    parkedBills,
    mapParkedList,
    selectParkedBill,
    selectLayAwayOrder,
    setAddCashFlag,
    setCouponInput,
    searchOrderHistory,
    getSalesHistoryData,
    orderHistoryDetails,
    setOrderHistoryDetails,
    ordersCopy,
    paymentModal,
    tillDataPaymentMethods,
    requestPayment,
    setCouponModalVisible,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    amount,
    setAmount,
    setNumb,
    onChangeAmount,
    paymentModalInputRef,
    processOrder,
    syncOrders,
    handleAmount,
    handleCashPayment,
    setOverPayedAmount,
    overPayedAmount,
    handleTotalQty,
    handleRealPrice,
    enterTotalQty,
    enterRealPrice,
    showPaymentMethods,
    setShowPaymentMethods,
    setCashAddInFlag,
    addCashFlag,
    isPrintModeXML,
    setSelectedKeys,
    setDisplayReturnOrderSearch,
    displayReturnOrderSearch,
    isProductsVisible,
    setIsProductsVisible,
    pickProduct,
    validateGiftCard,
    giftCardFlag,
    giftCardItems,
    setGiftCardType,
    setIsCardPaymentFlag,
    setIsGiftCardFlag,
    setKeyboardType,
    keyboardType,
    inputName,
    setInputName,
    keyboardInputFields,
    setKeyboardInputFields,
    keyboardRef,
    searchHistoryInput,
    setSearchhistoryInput,
    showEditOldCustomerFields,
    setEditFlag,
    openPaymentModalByCustomer,
    setSelectedProductInCart,
    setParkedBillSearchInput,
    salesHistoryCustomerSearchInput,
    salesHistoryDocumentNoSearchInput,
    setSalesHistoryCustomerSearchInput,
    setSalesHistoryDocumentNoSearchInput,
    quantityInputRef,
    setIsInputFocused,
    isInputFocused,
    getCategoryProducts,
    salesHistoryType,
    setStartRowData,
    startRowData,
    cartObj,
    documentSequence,
    setDocumnetSequence,
    notesValue,
    setNotesValue,
    selectedProductForNotes,
    setSelectedProductForNotes,
    couponModalVisible,
    displayCustomerSearch,
    displayAddNewCustomer,
    displayEditOldCustomer,
    isGiftCardFlag,
    manualDiscountModalVisible,
    loyalityOtpModalVisible,
    productsData,
    orderDelay,
    setOrderDelay,
    addToBagFlag,
    setAddToBagFlag,
    setStockList,
    stockList,
    displayUAECustomer,
    setDisplayUAECustomer,
    showSaleType,
    setShowSaleType,
    isSaleTypeFlag,
    setIsSaleTypeFlag,
    selectedSaleType,
    setSelectedSaleType,
    selectedSaleTypeData,
    setSelectedSaleTypeData,
    openSalesRep,
    setOpenSalesRep,
    manualDiscountForm,
    verifyStock,
    setIsStockModal,
    showPayments,
    setShowPayments,
    filteredPaymentMethods,
    setStartIndex,
    startIndex,
    getFilteredPaymentMethods,
    handleCartTotalClick,
    isShowingAll,
    setIsShowingAll,
    initialShowPayments,
    open,
    setOpen,
    productSearchInputRef,
    customerSearchInputRef,
    customerSearchInput,
    setCustomerSearchInput,
    layoutName,
    setLayoutName,
    giftCardRef,
    searchTerm,
    setSearchTerm,
    salesRepRef,
    salesRepValue,
    setSalesRepValue,
    selectedDocumentType,
    setSelectedDocumentType,
    showDocumentPopup,
    setShowDocumentPopup,
    documentTypes,
    keyboard,
    modifyProductList,
    currenciesData,
    calendarVisible,
    setCalendarVisible,
    selectedDate,
    setSelectedDate,
    cardPaymnetStatus,
    setCardPaymnetStatus,
    realPrice,
    setRealPrice,
    firstInputValue,
    setFirstInputValue,
    customMixItems,
    setCustomMixItems,
    existingGroupItems,
    setExistingGroupItems,
    selectedCustomMix,
    setSelectedCustomMix,
    groupQty,
    setGroupQty,
    setOrderType,
    posSaleTypes,
    setPosSaleTypes,
    setCurrenciesData,
    hasShownCustomerModalRef,
    showCustomMix,
    setShowCustomMix,
    additionalInfo,
    setAdditionalInfo,
    additionalInfoForm,
    couponInfo,
    options,
    setOptions,
    searchInputRef,
    activeInput,
    setActiveInput,
    qtyInputRef,
    deleteReceipt,
    totalBillDiscountData,
    setTotalBillDiscountData,
    discountAdditionalInfo,
    setDiscountAdditionalInfo,
    discountAdditionalInfoForm,
    processManualDiscount,
    discountInforApplication,
    setProductStock,
    showCustomerWallet,
    setShowCustomerWallet,
    customersData,
    setCustomersData,
    selectedCustomer,
    setSelectedCustomer,
    fetchWalletData,
    tillLink,
    setTillLink,
    showCompleteSaleStock,
    setShowCompleteSaleStock,
    completeSaleStockData,
    setCompleteSaleStockData,
    setPettCashIn,
    isWalletFlag,
    setIswalletFlag,
    setIsNewGiftCardFlag,
    setGiftCardMode,
    isRefundWalletOpen,
    setIsRefundWalletOpen,
    clearReturnCartData,
    cashIn,
    setCashIn,
    cashOut,
    setCashOut,
    pettyCashIn,
    setPettyCashIn,
    pettyCashOut,
    setPettyCashOut,
    processBillDiscounts,
    setLoader,
    processTotalManualDiscount,
    walletFunc,
    syncLoad,
    setSyncLoad,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
    setShowCardPaymnteModal,
    showCardPaymnteModal,
    dateRange,
    setDateRange,
    getDisplayDate,
    content,
    setPopoverVisible,
    isPopoverVisible,
    dateRef,
    isCardPaymentFlag,
    processCouponApplication,
    selectedCoupon,
    setSelectedCoupon,
    selectedExternalCouponType,
    setSelectedExternalCouponType,
    checkExternalCoupon,
    totalBillCouponData,
    setTotalBillCouponData,
    couponInputRef,
    setCardPaymnetError,
    redeemNumberRef,
    isOnline,
    setIsOnline,
    integratedPaymentStatus,
    setIntegratedPaymentStatus,
    isViewMode,
    setIsViewMode,
    toCamelCaseMetaData,
    convertMetaDataToKeyValue,
    viewCustomerValues,
    setViewCustomerValues,
    customerForm,
    setDisplayEditOldCustomer,
    setDisplayAddNewCustomer,
    setSelectedEditOldCustomer,
    formDataCache,
    setFormDataCache,
    retailCustomerFields,
    isParkedBill,
    setIsparkedBill,
    setTempCart,
    checkAndShowTcsModal,
    retrieveParkedData,
    discardMessage,
    handleOk,
    discardGiftCards,
    fetchOnlineBatches,
    onlineBatches,
    setOnlineBatches,
    isRefundCustomerEdit,
    setIsRefundCustomerEdit,
    addSelectedReturnProductsToCart,
    selectedReturnOrder,
    setSelectedReturnOrder,
    checkedKeys,
    setCheckedKeys,
    getProductData,
    dataSource,
    setDataSource,
    handleSaveReturnCartRecord,
    showReturnPurchase,
    setShowReturnPurchase,
    selectPurchaseBillForReturn,
    retrunSearchType,
    setReturnSearchType,
    searchReturnHistory,
    showReturnOptions,
    setShowReturnOptions,
    isBlindReceiptPending,
    setIsBlindReceiptPending,
    isPurchaseReturn,
    setIsPurchaseReturn,
    notesPopup,
    setNotesPopup,
    handleShift,
    rejectQuotation,
    setRejectQuotation,
    setModalEditState,
    modalEditState,
    returnProcessRef,
    customerConfigData,
    retailCustomerRules,
    autoEnablePanCustomer,
    autoEnableNriBilling,
    handlePayment,
    paymentType,
    setPaymentType,
    isNriBilling,
    setIsNriBilling,
    customerSearchResult,
    setCustomerSearchResults,
    isPanCustomer,
    setIsPanCustomer,
    isBankTransferOpen,
    setIsBankTransferOpen,
    bankTransferContext,
    setBankTransferContext,
    removeCoupon,
    debounceRef,
    enterRef,
    exchangeNotesValue,
    setExchangeNotesValue,
    activeCartTable,
    setActiveCartTable,
  } = props;
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage } = useSyncProgressStore();
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const posConfigData = { posType: usePOSConfigStore.getState().posType };
  const customerId = tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId;
  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const ObFlag = tillData.tillAccess.cwrTill.printTemplate.obController === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;
  const [tableValue, setTableValue] = useState("POS");
  const [reasonPopup, setReasonPopup] = useState(false);
  const [parkedBill, setParkedBill] = useState();
  const [keyValue, setKeyValue] = useState("0");
  const [reasonForm] = Form.useForm();
  const { width } = useWindowDimensions();
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [cashManagementData, setCashManagementData] = useState(false);
  const [productArray, setProductArray] = useState();
  const [productItems, setProductItems] = useState([]);
  const [isCashMangement, setIsCashManagement] = useState(false);
  const [productsDisplay, setProductDisplay] = useState("super-market");
  // BUG-1867: initialize from the persisted flag (not a hardcoded false) so a
  // browser refresh taken while the lock overlay is showing re-shows it instead
  // of dropping straight into the live POS screen. Engaging the lock previously
  // only set this in-memory; the persisted flag was written later, on the
  // Sign-In button click, which is too late to survive a refresh in between.
  const [isLocked, setIsLocked] = useState(() => useSessionStore.getState().locked === true);
  const lockScreen = (val) => {
    if (val) useSessionStore.getState().setLocked(true);
    setIsLocked(val);
  };
  const history = useHistory();
  const [clock1, setClock1] = useState(clock());
  const [enableProduction, setEnableProduction] = useState(posConfigData?.posType === "PRD" ? true : false);
  const [isQuotation, setIsQuotation] = useState(() => {
    const cartData = useCartStore.getState().cart;
    return cartData?.isQuotation ?? false;
  });
  const [showOrderSelection, setShowOrderSelection] = useState(false);
  const [saleTypeData, setSaleTypeData] = useState([]);
  const [calendarVisibleMap, setCalendarVisibleMap] = useState({});

  const [isSectionVisible, setIsSectionVisible] = useState(false);
  const showVirtualKeyboard = posConfig?.showKeyboard === "Y" ? true : false;
  const returnReasons = useAuthStore.getState().tillData.returnReasons;
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const tillAccessData = tillData?.tillAccess;
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};

  const productSearchRef = useRef(null);
  const productPanelSearchRef = useRef(null);
  const [viewStock, setViewStock] = useState(false);
  const selectBagRef = useRef(null);

  const [showPrintTemplateModal, setShowPrintTemplateModal] = useState(false);
  const [selectedPrintTemplate, setSelectedPrintTemplate] = useState(null);
  const [pendingReprintRecord, setPendingReprintRecord] = useState(null);
  const printTemplates = tillData?.tillAccess?.cwrTill?.printTemplates ? JSON.parse(tillData.tillAccess.cwrTill.printTemplates) : [];
  const enableMultiPrintTemplates = tillData?.tillAccess?.cwrTill?.enableMultiPrintTemplates === "Y";
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const exchangeCart = useTransactionStore.getState().selectedReturnType;
  const isStoreCredit = useTransactionStore.getState().selectedReturnType === "EXCHANGE";

  const realPriceRef = useRef(null);
  const [groupName, setGroupName] = useState("Custom Mix");
  const [expandTotals, setExpandTotals] = useState(false);
  const [showInputFields, setShowInputFields] = useState(false);
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

  // ── Hook initializations ────────────────────────────────────────────
  const {
    additionalCharges,
    setAdditionalCharges,
    tempSaleTypeData,
    setTempSaleTypeData,
    serviceChargeEnabled,
    setServiceChargeEnabled,
    serviceChargePercentage,
    setServiceChargePercentage,
    tipMode,
    setTipMode,
    tipPercentage,
    setTipPercentage,
    tipAmount,
    setTipAmount,
    deliveryCharge,
    setDeliveryCharge,
    packingCharge,
    setPackingCharge,
    tcsModalAmount,
    setTcsModalAmount,
    showTcsModal,
    setShowTcsModal,
    roundingOption,
    setRoundingOption,
    serviceChargeAmount,
    setServiceChargeAmount,
    tipTotal,
    setTipTotal,
    deliveryChargeAmount,
    setDeliveryChargeAmount,
    packingChargeAmount,
    setPackingChargeAmount,
    toFixedTruncate,
    applyRounding,
    compare,
    calculateCharge,
    computeTCS,
    handleApplyCharges,
    getChargeLabel,
    renderAdditionalChargesButton,
  } = useAdditionalCharges({ cart, setCart, pricePrecision, tillData, posConfig, themeJSON });

  const {
    activeTab,
    setActiveTab,
    loadingCart,
    setLoadingCart,
    cartHistoryData,
    setCartHistoryData,
    searchInput,
    setSearchInput,
    expandedRowKey,
    setExpandedRowKey,
    isEstimatesFlag,
    setIsEstimatesFlag,
    activeEstimatesTab,
    setActiveEstimatesTab,
    loadingEstimates,
    setLoadingEstimates,
    estimatesData,
    setEstimatesData,
    searchEstimatesInput,
    setSearchEstimatesInput,
    expandedEstimatesRowKey,
    setExpandedEstimatesRowKey,
    getCurrentMonthRange,
    getStatusForTab,
    getStatusForEstimatesTab,
    fetchCartHistory,
    handleTabChange,
    toggleExpand,
    handleRetrieve,
    handleCancelSale,
    fetchEstimates,
    handleRetrieveEstimate,
  } = useCartHistory({
    cart,
    setCart,
    tillData,
    isParkedBill,
    setIsparkedBill,
    setShowPaymentMethods,
    setOrderHistoryDetails,
    setSelectedProductInCart,
    setProductStock,
    setTempCart,
    setShowCompleteSaleStock,
    setCompleteSaleStockData,
    history,
    setSelectedDocumentType,
    getFilteredPaymentMethods,
    setShowPayments,
  });

  const {
    isReturn,
    setIsReturn,
    returnFlag,
    setReturnFlag,
    selectedRecords,
    setSelectedRecords,
    expandedRowKeys,
    setExpandedRowKeys,
    onSelectAllChange,
    onSelect,
    rowSelection,
    inputReturnQty,
    columns1,
    onFinish,
    handleBlindReturn,
    returnEnable,
    isReturnDisabled,
    shouldShowReturnButton,
    renderReturnAmount,
    renderExchangeAmount,
    renderTotalAmountText,
  } = useSuperMarketReturn({
    cart,
    setCart,
    tillData,
    posConfig,
    pricePrecision,
    dataSource,
    setDataSource,
    checkedKeys,
    setCheckedKeys,
    giftCardItems,
    handleSaveReturnCartRecord,
    handleCartTotalClick,
    setReasonPopup,
    setTillLink,
    setFilterDrawer,
    setShowReturnOptions,
    setIsBlindReceiptPending,
    setIsInputFocused,
  });

  const {
    getProductNearByStock,
    cancelOrder,
    handleDeletePayment,
    clearCart,
    handleLogout: handleLogoutFromHook,
  } = useSuperMarketHandlers({
    cart,
    setCart,
    tillData,
    posConfig,
    pricePrecision,
    orderType,
    documentSequence,
    setDocumnetSequence,
    deleteCart,
    setGiftCardData,
    giftCardData,
    selectedProductInCart,
    setStockList,
    handleLoyaltyPayment,
    getFilteredPaymentMethods,
    setShowPayments,
    setSelectedDocumentType,
    searchInputRef,
    setShowInputFields,
    setCustomMixItems,
    setGroupQty,
    setActiveInput,
    setProductSearchInput,
    discardGiftCards,
    removeCutomer,
    upsertPOSLog,
    posConfigData,
    domainURL,
    selectedSaleTypeData,
    setIsNriBilling,
    setIsPanCustomer,
    hasShownCustomerModalRef,
    selectedCustomer,
    setSelectedCustomer,
    getCurrentMonthRange,
    setAmount,
    isExchange,
    syncOrders,
  });

  const { productMap, setProductMap, productsList, setProductsList, handleSearch, onChangeInput, handleSelectProduct } = useProductSearch({
    posConfig,
    productSearchInput,
    setProductSearchInput,
    keyboard,
    pickProduct,
    setOptions,
    debounceRef,
    enterRef,
  });

  const debounceTimeoutRef = useRef(null);
  const isPendingFetchRef = useRef(false);
  const returnBillSearchInputRef = useRef();
  const showProductInfo = posConfig?.showProductInfoPanel === "Y" ? true : false;
  const shouldShowPanel = Object.keys(selectedProductInCart)?.length > 0 && showProductInfo;
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [offersDrawerOpen, setOffersDrawerOpen] = useState(false);

  const cartItems = useMemo(() => (cart?.items || []).filter((item) => item.weight !== 0), [cart?.items]);
  const hasExpandableRows = cartItems.some((item) => item.children && item.children.length > 0);

  // ── Handler functions (extracted to useSuperMarketActions hook) ──────
  const {
    handleOutsideClick,
    handleKey,
    handleKeyvalue,
    retrieveLayaway,
    onKeyPress,
    onChangeParkedBill,
    updateKeyboardInputs,
    removeProductModal,
    deleteProductModal,
    showMoreItems,
    showPreviousItems,
    cyclePaymentMethodByKeyboard,
    handleSave,
    modulo,
    handleExpand,
    handleExpandPerkedData,
    handleProductionClick,
    handleQuotationClick,
    handleViewStockClick,
    onClose,
    handleButtonClick,
    errorMessage,
    tillUnlink,
    handleLogin,
    handleLogout: handleLogoutFromActions,
    executeReprint,
    handleReceiptReprint,
    handlePrintTemplateConfirm,
    handlePrintTemplateCancel,
    renderInvoice,
    renderDocumentNo,
    handleDateSelect,
    toggleCalendar,
    loadingDetailOrderId,
  } = useSuperMarketActions({
    cart,
    setCart,
    tillData,
    posConfig,
    posConfigData,
    pricePrecision,
    keyboard,
    setOpen,
    setKeyValue,
    setSelectedKeys,
    setSelectedPaymentMethod,
    filterdParkedList,
    setFilterdParkedList,
    showOrderHistory,
    setSyncLoad,
    selectedSaleTypeData,
    setParkedBillSearchInput,
    setSearchhistoryInput,
    setCustomerSearchInput,
    setProductSearchInput,
    setSearchTerm,
    setKeyboardInputFields,
    form,
    inputName,
    setLayoutName,
    handleShift,
    onBarcodeInput,
    searchParkedBill,
    parkedBillSearchInput,
    searchOrderHistory,
    searchHistoryInput,
    dateRange,
    handleSelectProduct,
    deleteProduct,
    deleteCart,
    cancelOrder,
    parkBill,
    upsertPOSLog,
    selectLayAwayOrder,
    setIsInputFocused,
    setDataSource,
    dataSource,
    handleSaveReturnCartRecord,
    setDisplayReturnOrderSearch,
    getFilteredPaymentMethods,
    setShowPayments,
    setStartIndex,
    startIndex,
    handleDeletePayment,
    dispatchEvent,
    setPopoverVisible,
    isPopoverVisible,
    getSalesHistoryData,
    expandedRowKeys,
    setExpandedRowKeys,
    isPrintModeXML,
    ObFlag,
    CWHardwareController,
    enableMultiPrintTemplates,
    printTemplates,
    setPendingReprintRecord,
    setSelectedPrintTemplate,
    setShowPrintTemplateModal,
    isOnline,
    domainURL,
    redirectUrl,
    authHeaders,
    isLocked,
    handleLogoutFromHook,
    documentTypes,
    selectedDocumentType,
    setShowDocumentPopup,
    handleSearch,
    setSelectedDate,
    setCalendarVisible,
    searchInputRef,
    setSelectedProductForNotes,
    setNotesPopup,
    calendarVisibleMap,
    setCalendarVisibleMap,
    selectedDate,
    setShowCustomMix,
    keyboardInputFields,
    setIsQuotation,
    setTillLink,
    getProductNearByStock,
    setViewStock,
    selectedPrintTemplate,
    pendingReprintRecord,
  });

  const handleLogout = async () => {
    await handleLogoutFromActions(setLogoutLoading);
  };

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}`;

  let scrollLeft;
  let maxScroll;
  let currentScroll;
  const fetchMoreData = (event) => {
    const lengthOff = Number.parseInt(localStorage.getItem("dataLength") || "0", 10);
    let previousMaxScroll = maxScroll;
    let previousScroll = currentScroll;
    maxScroll = event.target.scrollHeight - event.target.clientHeight;
    currentScroll = event.target.scrollTop;
    if (scrollLeft !== event.target.scrollLeft) {
      scrollLeft = event.target.scrollLeft;
      return null;
    }
    if (Math.round(currentScroll) >= Math.round(maxScroll) - 1) {
      // The active date filter lives in a dedicated store field, not the sale's
      // orderType, so read it from salesHistoryFilter or pagination never resumes.
      let orderD = useTransactionStore.getState().salesHistoryFilter;
      if (isPendingFetchRef.current) return null;
      if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
      setLoading((prevLoading) => {
        if (orderD?.length > 0 && !prevLoading) {
          isPendingFetchRef.current = true;
          const scrollEl = document.querySelector(".sm-cart-table .ant-table-body");
          if (scrollEl) scrollEl.scrollTop = Math.round(currentScroll) - 5;
          let dateFlag = dateRef.current?.textContent === "Choose date range";
          debounceTimeoutRef.current = setTimeout(() => {
            // searchOrderHistory advances the dataLength offset itself (absolute), so the
            // next scroll continues from the correct row — no offset bookkeeping needed here.
            searchOrderHistory(orderD[0], orderD[1], lengthOff, true, dateFlag);
            isPendingFetchRef.current = false;
          }, 100);
        }
        return prevLoading;
      });
    }
  };

  // ── Side effects (extracted to useSuperMarketEffects hook) ──────────
  useSuperMarketEffects({
    cart,
    setCart,
    tillData,
    posConfig,
    selectedProductInCart,
    setSelectedProductInCart,
    setStockList,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
    isPurchaseReturn,
    searchCustomersRef,
    isParkedBill,
    parkedBillRef,
    themeJSON,
    isLocked,
    setIsOnline,
    getCategoryProducts,
    setProductSearchInput,
    keyboard,
    setKeyValue,
    paymentModal,
    addCashFlag,
    filterdParkedList,
    setCashManagementData,
    handleDeletePayment,
    orderHistoryDetails,
    setOrderHistoryDetails,
    manualDiscountModalVisible,
    manualDiscountForm,
    setManualDiscountInput,
    setSelectedManualDiscountTypeValue,
    handleOutsideClick,
    setSaleTypeData,
    setCurrentDateTime,
    orderDelay,
    setSyncLoad,
    selectedSaleTypeData,
    setTillLink,
    tillDataPaymentMethods,
    setPaymentType,
    handleKey,
    displayReturnOrderSearch,
    retrunSearchType,
    returnBillSearchInputRef,
    debounceTimeoutRef,
    isPendingFetchRef,
    fetchMoreData,
    showPaymentMethods,
    setAmount,
    pricePrecision,
    giftCardFlag,
    isGiftCardFlag,
    loyalityOtpModalVisible,
    isWalletFlag,
    isBankTransferOpen,
    showCardPaymnteModal,
    isCardPaymentFlag,
  });

  orderHistoryDetails.map((item) => {
    item.name = item.customer.name;
    item.status = item.isSynced === 1 || item.status === "Success" ? "Success" : "Pending";
  });

  const matchedSaleType = tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId;
  const renderCustomerWallet = () => renderCustomerWalletHelper({ posConfig, cartObj, matchedSaleType, fetchWalletData });
  const reconstructedObject = parseTillAccessMeta(tillData);
  const showConfirm = () => showConfirmHelper({ cart, amount, pricePrecision, posConfig, overPayedAmount });
  const renderPaymentsData = () => renderPaymentsDataHelper({ cart, isExchange, currenciesList, pricePrecision, handleDeletePayment });
  const watermark = () => watermarkHelper({ cart, posConfig });

  let barcodeFlag = false;
  const inputElement = document.getElementById("sm-customer-search");
  const amountInput = document.getElementById("sm-amount-input");
  const totalAmountInout = document.getElementById("sm-total-amount-input");
  const inputFocused = inputElement === document.activeElement || amountInput === document.activeElement || totalAmountInout === document.activeElement;
  const approvalFlag = useTransactionStore.getState().approvalFlag || "1";
  if (
    !couponModalVisible &&
    !displayAddNewCustomer &&
    !validateGiftCard &&
    !displayCustomerSearch &&
    !displayEditOldCustomer &&
    !giftCardFlag &&
    !filterDrawer &&
    !isGiftCardFlag &&
    !manualDiscountModalVisible &&
    !loyalityOtpModalVisible &&
    !inputFocused &&
    !showCardPaymnteModal &&
    !showCustomMix &&
    approvalFlag === "1"
  ) {
    barcodeFlag = true;
  }

  if (props.layoutShortcutHandlersRef) {
    props.layoutShortcutHandlersRef.current = {
      additionalCharges: () => setAdditionalCharges(true),
      printReceipt: () => {
        const lastOrder = JSON.parse(localStorage.getItem("lastOrderData") || "null");
        if (lastOrder) handleReceiptReprint(lastOrder);
      },
    };
  }

  const mainDivStyles = themeJSON.appBgImageURL
    ? { backgroundImage: `url(${themeJSON.appBgImageURL})`, height: "100vh", width: "100%", display: isLocked || isSectionVisible ? "none" : "block" }
    : { backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%", display: isLocked || isSectionVisible ? "none" : "block" };
  document.querySelectorAll("amt-dial-btn-market").forEach((element) => {
    element.style.backgroundColor = themeJSON.keyBoardColor;
  });

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} spin />} spinning={loading}>
      {isParkedBill ? (
        posConfig?.saveParkedBills === "Y" ? (
          <CartHistoryView
            colorVariable={colorVariable}
            setIsparkedBill={setIsparkedBill}
            setIsInputFocused={setIsInputFocused}
            setParkedBillSearchInput={setParkedBillSearchInput}
            setLayoutName={setLayoutName}
            setCartHistoryData={setCartHistoryData}
            setExpandedRowKey={setExpandedRowKey}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            getStatusForTab={getStatusForTab}
            fetchCartHistory={fetchCartHistory}
            handleTabChange={handleTabChange}
            loadingCart={loadingCart}
            cartHistoryData={cartHistoryData}
            expandedRowKey={expandedRowKey}
            toggleExpand={toggleExpand}
            handleRetrieve={handleRetrieve}
            handleCancelSale={handleCancelSale}
          />
        ) : (
          <SMParkedBillsView
            colorVariable={colorVariable}
            posConfig={posConfig}
            themeJSON={themeJSON}
            isParkedBill={isParkedBill}
            setIsparkedBill={setIsparkedBill}
            setIsInputFocused={setIsInputFocused}
            setParkedBillSearchInput={setParkedBillSearchInput}
            setLayoutName={setLayoutName}
            parkedBillSearchInput={parkedBillSearchInput}
            searchParkedBill={searchParkedBill}
            onChangeParkedBill={onChangeParkedBill}
            keyboard={keyboard}
            setInputName={setInputName}
            setOpen={setOpen}
            filterdParkedList={filterdParkedList}
            setFilterdParkedList={setFilterdParkedList}
            parkedList={parkedList}
            columns={parkedBillColumns}
            selectedKeys={selectedKeys}
            expandedRowKeys={expandedRowKeys}
            handleExpandPerkedData={handleExpandPerkedData}
            tillData={tillData}
            pricePrecision={pricePrecision}
            setTableValue={setTableValue}
            retrieveParkedData={retrieveParkedData}
            upsertPOSLog={upsertPOSLog}
            cart={cart}
            setCart={setCart}
            setParkedBill={setParkedBill}
            discardMessage={discardMessage}
            parkedBillRef={parkedBillRef}
            setShowPaymentMethods={setShowPaymentMethods}
            setOrderHistoryDetails={setOrderHistoryDetails}
            setSelectedProductInCart={setSelectedProductInCart}
            setProductStock={setProductStock}
            setTempCart={setTempCart}
            setShowCompleteSaleStock={setShowCompleteSaleStock}
            setCompleteSaleStockData={setCompleteSaleStockData}
          />
        )
      ) : isEstimatesFlag ? (
        <SMEstimatesView
          colorVariable={colorVariable}
          isEstimatesFlag={isEstimatesFlag}
          setIsEstimatesFlag={setIsEstimatesFlag}
          tillData={tillData}
          cart={cart}
          setCart={setCart}
          setShowPaymentMethods={setShowPaymentMethods}
          setOrderHistoryDetails={setOrderHistoryDetails}
          setSelectedProductInCart={setSelectedProductInCart}
          setProductStock={setProductStock}
          setTempCart={setTempCart}
          setShowCompleteSaleStock={setShowCompleteSaleStock}
          setCompleteSaleStockData={setCompleteSaleStockData}
          history={history}
          posConfig={posConfig}
        />
      ) : isCashMangement ? (
        <SMCashManagementView
          colorVariable={colorVariable}
          themeJSON={themeJSON}
          cashManagementData={cashManagementData}
          setIsCashManagement={setIsCashManagement}
          setAddCashFlag={setAddCashFlag}
          setCashAddInFlag={setCashAddInFlag}
          posConfig={posConfig}
          selectBagRef={selectBagRef}
          offersDrawerOpen={offersDrawerOpen}
          setOffersDrawerOpen={setOffersDrawerOpen}
          setOnlineBatches={setOnlineBatches}
          onlineBatches={onlineBatches}
          fetchOnlineBatches={fetchOnlineBatches}
          retailModalsProps={props}
        />
      ) : isQuotation ? (
        <QuotationComponent
          formattedDateTime={formattedDateTime}
          setShowProductionOrder={setShowProductionOrder}
          removeProductModal={removeProductModal}
          deleteProductModal={deleteProductModal}
          setTillLink={setTillLink}
          setIsQuotation={setIsQuotation}
          onChangeInput={onChangeInput}
          setOpen={setOpen}
          productSearchInputRef={productSearchInputRef}
          {...props}
        />
      ) : isPurchaseReturn ? (
        <SMPurchaseReturnView
          colorVariable={colorVariable}
          showReturnPurchase={showReturnPurchase}
          setShowReturnPurchase={setShowReturnPurchase}
          setIsPurchaseReturn={setIsPurchaseReturn}
          setStartRowData={setStartRowData}
          setOrderHistoryDetails={setOrderHistoryDetails}
          setExpandedRowKeys={setExpandedRowKeys}
          expandedRowKeys={expandedRowKeys}
          setDateRange={setDateRange}
          setFiltersFlag={setFiltersFlag}
          filtersFlag={filtersFlag}
          setIsInputFocused={setIsInputFocused}
          setSearchhistoryInput={setSearchhistoryInput}
          setLayoutName={setLayoutName}
          searchCustomersRef={searchCustomersRef}
          searchHistoryInput={searchHistoryInput}
          searchOrderHistory={searchOrderHistory}
          dateRange={dateRange}
          setOpen={setOpen}
          setInputName={setInputName}
          keyboard={keyboard}
          themeJSON={themeJSON}
          tableBodyRef={null}
          orderHistoryColumns={orderHistoryColumns}
          orderHistoryDetails={orderHistoryDetails}
          selectedKeys={selectedKeys}
          handleExpand={handleExpand}
          content={content}
          isPopoverVisible={isPopoverVisible}
          setPopoverVisible={setPopoverVisible}
          handleButtonClick={handleButtonClick}
          getDisplayDate={getDisplayDate}
          ordersCopy={ordersCopy}
          isReturn={isReturn}
          reconstructedObject={reconstructedObject}
          handleReceiptReprint={handleReceiptReprint}
          posConfig={posConfig}
          filterdParkedList={filterdParkedList}
          prevHistoryRef={prevHistoryRef}
          setCheckedKeys={setCheckedKeys}
          checkedKeys={checkedKeys}
          searchReturnHistory={searchReturnHistory}
          Discard={Discard}
          selectedReturnOrder={selectedReturnOrder}
          pricePrecision={pricePrecision}
          dataSource={dataSource}
          setDataSource={setDataSource}
          handleSaveReturnCartRecord={handleSaveReturnCartRecord}
          setModalEditState={setModalEditState}
          modalEditState={modalEditState}
          loader={loader}
          // detailsLoading={detailsLoading}
          returnProcessRef={returnProcessRef}
          setShowReturnOptions={setShowReturnOptions}
          dateRef={dateRef}
          tillData={tillData}
          setSelectedDocumentType={setSelectedDocumentType}
          retrieveLayaway={retrieveLayaway}
          setSelectedSaleTypeData={setSelectedSaleTypeData}
          updateSaleTypeInStore={(item) => {
            usePOSConfigStore.getState().setSaleTypeData(item);
          }}
          setSelectedSaleType={setSelectedSaleType}
          getFilteredPaymentMethods={getFilteredPaymentMethods}
          setStartIndex={setStartIndex}
          setShowPayments={setShowPayments}
          giftCardItems={giftCardItems}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          setKeyValue={setKeyValue}
          setSelectedKeys={setSelectedKeys}
          addSelectedReturnProductsToCart={addSelectedReturnProductsToCart}
          loadingDetailOrderId={loadingDetailOrderId}
          dispatchEvent={dispatchEvent}
        />
      ) : !syncLoad ? (
        <>
          <div
            style={{
              ...mainDivStyles,
              height: "100vh",
              overflow: "hidden",
            }}
          >
            <SMHeader
              setTillLink={setTillLink}
              setProductSearchInput={setProductSearchInput}
              themeJSON={themeJSON}
              showSaleType={showSaleType}
              selectedSaleType={selectedSaleType}
              setIsSaleTypeFlag={setIsSaleTypeFlag}
              cart={cart}
              formattedDateTime={formattedDateTime}
              posConfig={posConfig}
              setShowCustomMix={setShowCustomMix}
              isOnline={isOnline}
              setIsLocked={lockScreen}
              userData={userData}
              errorMessage={errorMessage}
            />

            {barcodeFlag ? (
              posConfig?.noFocus === "Y" ? (
                <BarCodeComponentForNoFocus onScan={onBarcodeInput} setProductSearchInput={setProductSearchInput} productSearchInput={productSearchInput} />
              ) : (
                <BarCodeComponentForRetail onScan={onBarcodeInput} setProductSearchInput={setProductSearchInput} productSearchInput={productSearchInput} />
              )
            ) : null}

            {/* {barcodeFlag && <BarCodeComponentForRetail onScan={onBarcodeInput} setProductSearchInput={setProductSearchInput} productSearchInput={productSearchInput} />} */}

            <div style={{ display: "flex", height: "91vh" }}>
              {/* Left side UI */}
              <div style={{ width: "63.9%" }}>
                <div
                  data-zone="search"
                  data-zone-label="Product Search"
                  style={{
                    display: "flex",
                    width: "100%",
                    padding: "0 0 0 1.7%",
                  }}
                >
                  <div style={{ width: "93%" }}>
                    <RenderInput
                      posConfig={posConfig}
                      options={options}
                      productMap={productMap}
                      pickProduct={pickProduct}
                      productSearchInput={productSearchInput}
                      setProductSearchInput={setProductSearchInput}
                      setOptions={setOptions}
                      keyboard={keyboard}
                      filterDrawer={filterDrawer}
                      activeInput={activeInput}
                      searchInputRef={searchInputRef}
                      clearProductSearchResults={clearProductSearchResults}
                      onChangeInput={onChangeInput}
                      setOpen={setOpen}
                      setInputName={setInputName}
                      setIsInputFocused={setIsInputFocused}
                      onBarcodeInput={onBarcodeInput}
                      productSearchInputRef={productSearchInputRef}
                    />
                  </div>
                  <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      // width: "4.5%",
                      margin: "0 0.2vw 0 0.8vw",
                      borderRadius: "7px",
                      height: "inherit",
                      borderColor: "#fff",
                    }}
                    onClick={() => setIsProductsFilter(true)}
                  >
                    <img src={ScanIcon} style={{ height: "2.7vh" }} />
                  </Button>
                  <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      // width: "4.5%",
                      margin: "0 1vw 0 0.5vw",
                      borderRadius: "7px",
                      height: "inherit",
                      borderColor: "#fff",
                    }}
                    id="sm-product-drawer"
                    // onClick={() => setIsProductsFilter(true)}
                    onClick={() => {
                      setFilterDrawer(true);
                    }}
                  >
                    <img src={FilterIcon} style={{ height: "2.7vh" }} />
                  </Button>
                </div>
                <SMCartTable
                  cart={cart}
                  cartItems={cartItems}
                  hasExpandableRows={hasExpandableRows}
                  posConfig={posConfig}
                  themeJSON={themeJSON}
                  pricePrecision={pricePrecision}
                  currenciesList={currenciesList}
                  tillData={tillData}
                  selectedProductInCart={selectedProductInCart}
                  selectedRowKeys={selectedRowKeys}
                  isExchange={isExchange}
                  watermark={watermark}
                  renderInvoice={renderInvoice}
                  renderDocumentNo={renderDocumentNo}
                  renderReturnAmount={renderReturnAmount}
                  renderExchangeAmount={renderExchangeAmount}
                  selectProductInCart={selectProductInCart}
                  setSelectedProductInCart={setSelectedProductInCart}
                  clearSelectedProductInCart={clearSelectedProductInCart}
                  removeProductModal={removeProductModal}
                  setShowPaymentMethods={setShowPaymentMethods}
                  setNotesPopup={setNotesPopup}
                  setNotesValue={setNotesValue}
                  setSelectedProductForNotes={setSelectedProductForNotes}
                  setIsInputFocused={setIsInputFocused}
                  setShowInputFields={setShowInputFields}
                  setCustomMixItems={setCustomMixItems}
                  setGroupQty={setGroupQty}
                  setActiveInput={setActiveInput}
                  searchInputRef={searchInputRef}
                  qtyInputRef={qtyInputRef}
                  setSelectedCustomMix={setSelectedCustomMix}
                  setGroupName={setGroupName}
                  setExistingGroupItems={setExistingGroupItems}
                  setShowCustomMix={setShowCustomMix}
                  setOverPayedAmount={setOverPayedAmount}
                  setAmount={setAmount}
                  setQtyNumberFlag={setQtyNumberFlag}
                  setRealPrice={setRealPrice}
                  setFirstInputValue={setFirstInputValue}
                  setStockList={setStockList}
                  setOpenSalesRep={setOpenSalesRep}
                  setDisplayCustomerSearch={setDisplayCustomerSearch}
                  setCloseCustomerFlag={setCloseCustomerFlag}
                  setProductSearchInput={setProductSearchInput}
                  handleDateSelect={handleDateSelect}
                  setCart={setCart}
                  removeCoupon={removeCoupon}
                  notesValue={notesValue}
                  exchangeNotesValue={exchangeNotesValue}
                  setExchangeNotesValue={setExchangeNotesValue}
                  activeCartTable={activeCartTable}
                  setActiveCartTable={setActiveCartTable}
                />
                <SMCartSummary
                  cart={cart}
                  currenciesList={currenciesList}
                  pricePrecision={pricePrecision}
                  themeJSON={themeJSON}
                  isExchange={isExchange}
                  tempSaleTypeData={tempSaleTypeData}
                  expandTotals={expandTotals}
                  setExpandTotals={setExpandTotals}
                  verifyStock={verifyStock}
                  openDisplayParkedBillModal={openDisplayParkedBillModal}
                  deleteProductModal={deleteProductModal}
                  toFixedTruncate={toFixedTruncate}
                />
              </div>
              {/* Right side UI */}
              <div
                style={{
                  width: "35.6%",
                  padding: "0% 0% 0 0.4%",
                  borderRadius: "10px",
                  paddingBottom: "0",
                  height: "89vh",
                  marginRight: "1%",
                }}
              >
                <SMCustomerBar
                  cart={cart}
                  tillData={tillData}
                  customerId={customerId}
                  retailCustomerFields={retailCustomerFields}
                  convertMetaDataToKeyValue={convertMetaDataToKeyValue}
                  customerForm={customerForm}
                  autoEnablePanCustomer={autoEnablePanCustomer}
                  autoEnableNriBilling={autoEnableNriBilling}
                  setViewCustomerValues={setViewCustomerValues}
                  setSelectedEditOldCustomer={setSelectedEditOldCustomer}
                  setDisplayEditOldCustomer={setDisplayEditOldCustomer}
                  setDisplayAddNewCustomer={setDisplayAddNewCustomer}
                  setIsViewMode={setIsViewMode}
                  setEditFlag={setEditFlag}
                  showEditOldCustomerFields={showEditOldCustomerFields}
                  setDisplayCustomerSearch={setDisplayCustomerSearch}
                  setCloseCustomerFlag={setCloseCustomerFlag}
                  setProductSearchInput={setProductSearchInput}
                  removeCutomer={removeCutomer}
                  showAddNewCustomerFields={showAddNewCustomerFields}
                  viewCustomerValues={viewCustomerValues}
                />
                <div style={{ display: "flex", fontSize: "1vw" }}>
                  <SMCartMenuButtons
                    themeJSON={themeJSON}
                    tillAccessData={tillAccessData}
                    posConfig={posConfig}
                    cart={cart}
                    isOnline={isOnline}
                    isStoreCredit={isStoreCredit}
                    selectedProductInCart={selectedProductInCart}
                    pricePrecision={pricePrecision}
                    manualDiscountForm={manualDiscountForm}
                    openDisplayParkedBillModal={openDisplayParkedBillModal}
                    setManualDiscountModalVisible={setManualDiscountModalVisible}
                    setManualDiscountInput={setManualDiscountInput}
                    setSelectedManualDiscountTypeValue={setSelectedManualDiscountTypeValue}
                    setProductSearchInput={setProductSearchInput}
                    renderAdditionalChargesButton={renderAdditionalChargesButton}
                    setReturnFlag={setReturnFlag}
                    setIsPurchaseReturn={setIsPurchaseReturn}
                    setIsCashManagement={setIsCashManagement}
                    handleKeyvalue={handleKeyvalue}
                    setIsEstimatesFlag={setIsEstimatesFlag}
                    setGiftCardType={setGiftCardType}
                    setIsGiftCardFlag={setIsGiftCardFlag}
                    setIsNewGiftCardFlag={setIsNewGiftCardFlag}
                    setGiftCardMode={setGiftCardMode}
                    setAddToBagFlag={setAddToBagFlag}
                    setOpenSalesRep={setOpenSalesRep}
                    setIsparkedBill={setIsparkedBill}
                    setParkedBillSearchInput={setParkedBillSearchInput}
                    clearReturnCartData={clearReturnCartData}
                    setDateRange={setDateRange}
                    setExpandedRowKeys={setExpandedRowKeys}
                    setSearchhistoryInput={setSearchhistoryInput}
                    setOrderHistoryDetails={setOrderHistoryDetails}
                    setFiltersFlag={setFiltersFlag}
                    setShowReturnPurchase={setShowReturnPurchase}
                    searchOrderHistory={searchOrderHistory}
                    errorMessage={errorMessage}
                  />
                  <SMProductDetailsPanel
                    showPaymentMethods={showPaymentMethods}
                    shouldShowPanel={shouldShowPanel}
                    stockList={stockList}
                    setStockList={setStockList}
                    selectedProductInCart={selectedProductInCart}
                    currenciesList={currenciesList}
                    pricePrecision={pricePrecision}
                    posConfig={posConfig}
                    handleViewStockClick={handleViewStockClick}
                    modifyProductList={modifyProductList}
                    cart={cart}
                    onChangeTotalQuantity={onChangeTotalQuantity}
                    setIsInputFocused={setIsInputFocused}
                    setActiveInput={setActiveInput}
                    enterTotalQty={enterTotalQty}
                    handleTotalQty={handleTotalQty}
                    decreaseProductQty={decreaseProductQty}
                    increaseProductQty={increaseProductQty}
                    showInputFields={showInputFields}
                    qtyInputRef={qtyInputRef}
                    realPrice={realPrice}
                    setRealPrice={setRealPrice}
                    enterRealPrice={enterRealPrice}
                    handleRealPrice={handleRealPrice}
                    realPriceRef={realPriceRef}
                  />

                  <SMPaymentBar
                    showPaymentMethods={showPaymentMethods}
                    showPayments={showPayments}
                    filteredPaymentMethods={filteredPaymentMethods}
                    posConfig={posConfig}
                    cart={cart}
                    tillData={tillData}
                    currenciesList={currenciesList}
                    selectedPaymentMethod={selectedPaymentMethod}
                    setSelectedPaymentMethod={setSelectedPaymentMethod}
                    amount={amount}
                    setAmount={setAmount}
                    setNumb={setNumb}
                    onChangeAmount={onChangeAmount}
                    handleAmount={handleAmount}
                    handleCashPayment={handleCashPayment}
                    setOverPayedAmount={setOverPayedAmount}
                    overPayedAmount={overPayedAmount}
                    setIsCardPaymentFlag={setIsCardPaymentFlag}
                    isCardPaymentFlag={isCardPaymentFlag}
                    paymentModalInputRef={paymentModalInputRef}
                    setIsInputFocused={setIsInputFocused}
                    setShowInputFields={setShowInputFields}
                    setShowCardPaymnteModal={setShowCardPaymnteModal}
                    setPaymentType={setPaymentType}
                    setCardPaymnetError={setCardPaymnetError}
                    walletFunc={walletFunc}
                    verifyStock={verifyStock}
                    processOrder={processOrder}
                    requestPayment={requestPayment}
                    handlePayment={handlePayment}
                    showConfirm={showConfirm}
                    isOnline={isOnline}
                    isExchange={isExchange}
                    exchangeCart={exchangeCart}
                    customerConfigData={customerConfigData}
                    retailCustomerFields={retailCustomerFields}
                    pricePrecision={pricePrecision}
                    themeJSON={themeJSON}
                    currenciesData={currenciesData}
                    denaminationsKeyboard={denaminationsKeyboard}
                    setDenaminationsKeyboard={setDenaminationsKeyboard}
                    isShowingAll={isShowingAll}
                    showMoreItems={showMoreItems}
                    showPreviousItems={showPreviousItems}
                    cyclePaymentMethodByKeyboard={cyclePaymentMethodByKeyboard}
                    modulo={modulo}
                    renderPaymentsData={renderPaymentsData}
                    CWHardwareController={CWHardwareController}
                    setIsNewGiftCardFlag={setIsNewGiftCardFlag}
                    setGiftCardMode={setGiftCardMode}
                    setIsBankTransferOpen={setIsBankTransferOpen}
                    setBankTransferContext={setBankTransferContext}
                  />
                </div>
              </div>
            </div>

            {isProductsVisible && (
              <Drawer
                placement="bottom"
                height="75vh"
                title={null}
                closeIcon={null}
                className="filter"
                styles={{ header: { height: 0 } }}
                styles={{ body: { paddingTop: 0 } }}
                open={true}
                closable={true}
                onClose={closeProductPanel}
                footer={null}
              >
                <Row
                  style={{
                    paddingTop: isQtyUpdate ? 0 : "1.7%",
                    width: "100%",
                    paddingLeft: "1vw",
                  }}
                >
                  <ProductPanelSM
                    checkIsManualWeight={checkIsManualWeight}
                    setIsSearchProducts={setIsSearchProducts}
                    getMoreProducts={getMoreProducts}
                    productItems={productItems}
                    setProductItems={setProductItems}
                    selectProductInCart={selectProductInCart}
                    setProductArray={setProductArray}
                    isProductsFilter={isProductsFilter}
                    getSearchedProducts={getSearchedProducts}
                    productListCardRef={productListCardRef}
                    productsDisplay={productsDisplay}
                    setIsProductsVisible={setIsProductsVisible}
                    pickProduct={pickProduct}
                    filterDrawer={filterDrawer}
                    setFilterDrawer={setFilterDrawer}
                    productSearchInput={productSearchInput}
                    setProductSearchInput={setProductSearchInput}
                    setOpen={setOpen}
                    keyboardType={keyboardType}
                    setKeyboardType={setKeyboardType}
                    productSearchInputRef={productSearchInputRef}
                    clearProductSearchResults={clearProductSearchResults}
                    productsData={productsData}
                    isProductsVisible={isProductsVisible}
                    productSearchRef={productSearchRef}
                    handleSelectProduct={handleSelectProduct}
                    productsList={productsList}
                    setProductsList={setProductsList}
                    setLayoutName={setLayoutName}
                    productPanelSearchRef={productPanelSearchRef}
                    setInputName={setInputName}
                    keyboard={keyboard}
                    searchInputRef={searchInputRef}
                    stockList={stockList}
                    setStockList={setStockList}
                    selectedProductInCart={selectedProductInCart}
                    setCart={setCart}
                  />
                </Row>
              </Drawer>
            )}
            {isQtyUpdate ? (
              <QuantityUpdate
                selectedProductInCart={selectedProductInCart}
                addProduct={addProduct}
                setIsQtyUpdate={setIsQtyUpdate}
                isQtyUpdate={isQtyUpdate}
                increaseProductQty={increaseProductQty}
                decreaseProductQty={decreaseProductQty}
                removeProductModal={removeProductModal}
                setIsSearchProducts={setIsSearchProducts}
              />
            ) : (
              ""
            )}
            <ProductPanelSM
              checkIsManualWeight={checkIsManualWeight}
              setIsSearchProducts={setIsSearchProducts}
              getMoreProducts={getMoreProducts}
              productItems={productItems}
              setProductItems={setProductItems}
              selectProductInCart={selectProductInCart}
              setProductArray={setProductArray}
              isProductsFilter={isProductsFilter}
              getSearchedProducts={getSearchedProducts}
              productListCardRef={productListCardRef}
              productsDisplay={productsDisplay}
              setIsProductsVisible={setIsProductsVisible}
              pickProduct={pickProduct}
              filterDrawer={filterDrawer}
              setFilterDrawer={setFilterDrawer}
              productSearchInput={productSearchInput}
              setProductSearchInput={setProductSearchInput}
              setOpen={setOpen}
              keyboardType={keyboardType}
              setKeyboardType={setKeyboardType}
              productSearchInputRef={productSearchInputRef}
              clearProductSearchResults={clearProductSearchResults}
              productsData={productsData}
              productSearchRef={productSearchRef}
              handleSelectProduct={handleSelectProduct}
              productsList={productsList}
              setProductsList={setProductsList}
              setLayoutName={setLayoutName}
              productPanelSearchRef={productPanelSearchRef}
              setInputName={setInputName}
              keyboard={keyboard}
              searchInputRef={searchInputRef}
              stockList={stockList}
              setStockList={setStockList}
              selectedProductInCart={selectedProductInCart}
              setCart={setCart}
            />
            <RetailModals
              {...props}
              selectBagRef={selectBagRef}
              offersDrawerOpen={offersDrawerOpen}
              setOffersDrawerOpen={setOffersDrawerOpen}
              setOnlineBatches={setOnlineBatches}
              onlineBatches={onlineBatches}
              fetchOnlineBatches={fetchOnlineBatches}
            />
          </div>
          <SMLockScreen colorVariable={colorVariable} isLocked={isLocked} isOnline={isOnline} userData={userData} username={authHeaders?.username} handleLogin={handleLogin} />

          <SMOrderSelectionView
            colorVariable={colorVariable}
            isSectionVisible={isSectionVisible}
            isOnline={isOnline}
            form={form}
            onFinish={onFinish}
            showOrderSelection={showOrderSelection}
            setShowOrderSelection={setShowOrderSelection}
            setIsSectionVisible={setIsSectionVisible}
          />
        </>
      ) : (
        <>
          <LoadingScreen
            colorVariable={colorVariable}
            POSLogo={POSLogo}
            formattedDateTime={formattedDateTime}
            clock1={clock1}
            leftLoading={leftLoading}
            percent={percent}
            productCategoryPercentage={productCategoryPercentage}
            productPercentage={productPercentage}
            promotionPercentage={promotionPercentage}
          />
        </>
      )}

      {open && showVirtualKeyboard && (
        <SMVirtualKeyboardDrawer
          open={open}
          setOpen={setOpen}
          showVirtualKeyboard={showVirtualKeyboard}
          keyboard={keyboard}
          layoutName={layoutName}
          setLayoutName={setLayoutName}
          inputName={inputName}
          updateKeyboardInputs={updateKeyboardInputs}
          onKeyPress={onKeyPress}
        />
      )}

      {tillLink && (
        <SideMenuDrawer
          tillLink={tillLink}
          setTillLink={setTillLink}
          setActiveInput={setActiveInput}
          searchInputRef={searchInputRef}
          tillData={tillData}
          posConfig={posConfig}
          cart={cart}
          setCart={setCart}
          tillUnlink={tillUnlink}
          enableProduction={enableProduction}
          setCouponModalVisible={setCouponModalVisible}
          setCouponInput={setCouponInput}
          dispatchEvent={dispatchEvent}
          reconstructedObject={reconstructedObject}
          CWHardwareController={CWHardwareController}
          setShowPaymentMethods={setShowPaymentMethods}
          processOrder={processOrder}
          upsertPOSLog={upsertPOSLog}
          isReturnDisabled={isReturnDisabled}
          shouldShowReturnButton={shouldShowReturnButton}
          setFilterDrawer={setFilterDrawer}
          setShowReturnOptions={setShowReturnOptions}
          setIsBlindReceiptPending={setIsBlindReceiptPending}
          setReasonPopup={setReasonPopup}
          handleCartTotalClick={handleCartTotalClick}
          isOnline={isOnline}
          errorMessage={errorMessage}
          setSyncLoad={setSyncLoad}
          selectedSaleTypeData={selectedSaleTypeData}
          parkedList={parkedList}
          handleKeyvalue={handleKeyvalue}
          setIsparkedBill={setIsparkedBill}
          setManualDiscountModalVisible={setManualDiscountModalVisible}
          setDisplayUAECustomerSearch={setDisplayUAECustomerSearch}
          handleProductionClick={handleProductionClick}
          renderCustomerWallet={renderCustomerWallet}
          logoutLoading={logoutLoading}
          handleLogout={handleLogout}
          setOffersDrawerOpen={setOffersDrawerOpen}
          deleteReceipt={deleteReceipt}
          cartObj={cartObj}
          matchedSaleType={matchedSaleType}
          fetchWalletData={fetchWalletData}
        />
      )}
      {additionalCharges && (
        <AdditionalChargesDrawer
          additionalCharges={additionalCharges}
          setAdditionalCharges={setAdditionalCharges}
          tempSaleTypeData={tempSaleTypeData}
          getChargeLabel={getChargeLabel}
          cart={cart}
        />
      )}
      {showTcsModal && (
        <Modal open={true} footer={null} centered onCancel={() => setShowTcsModal(false)}>
          <div style={{ padding: 20, textAlign: "center" }}>
            <h3 style={{ marginBottom: 10 }}>TCS Applied</h3>
            <p style={{ fontSize: "18px", fontWeight: "bold" }}>₹ {tcsModalAmount}</p>
          </div>
        </Modal>
      )}
      {reasonPopup && (
        <SMReturnReasonDrawer
          reasonPopup={reasonPopup}
          setReasonPopup={setReasonPopup}
          setIsInputFocused={setIsInputFocused}
          reasonForm={reasonForm}
          onFinish={onFinish}
          posConfig={posConfig}
          returnReasons={returnReasons}
        />
      )}

      {showCustomMix && (
        <CustomMixModal
          showCustomMix={showCustomMix}
          setShowCustomMix={setShowCustomMix}
          cart={cart}
          setCart={setCart}
          customMixItems={customMixItems}
          setCustomMixItems={setCustomMixItems}
          groupName={groupName}
          setGroupName={setGroupName}
          groupQty={groupQty}
          setGroupQty={setGroupQty}
          existingGroupItems={existingGroupItems}
          setExistingGroupItems={setExistingGroupItems}
          selectedCustomMix={selectedCustomMix}
          setSelectedCustomMix={setSelectedCustomMix}
          orderType={orderType}
          setOrderType={setOrderType}
          posSaleTypes={posSaleTypes}
          setPosSaleTypes={setPosSaleTypes}
          currenciesData={currenciesData}
          setCurrenciesData={setCurrenciesData}
          searchInputRef={searchInputRef}
          setProductStock={setProductStock}
          setShowCompleteSaleStock={setShowCompleteSaleStock}
          setCompleteSaleStockData={setCompleteSaleStockData}
          processBillDiscounts={processBillDiscounts}
          setLoader={setLoader}
          processTotalManualDiscount={processTotalManualDiscount}
        />
      )}
      {showPrintTemplateModal && (
        <SMPrintTemplateModal
          showPrintTemplateModal={showPrintTemplateModal}
          selectedPrintTemplate={selectedPrintTemplate}
          setSelectedPrintTemplate={setSelectedPrintTemplate}
          handlePrintTemplateCancel={handlePrintTemplateCancel}
          handlePrintTemplateConfirm={handlePrintTemplateConfirm}
          printTemplates={printTemplates}
        />
      )}
    </Spin>
  );
};

export default PointOfSaleMarket;
